import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { IconSizesEnum, IIcon } from 'i2g-ng-ui';
import {
  I2gNgTrackingActionBuilder,
  I2gNgTrackingService,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import {
  CtaButtonIdentifierEnum,
  MOBILE_DEEPLINK,
  VERIFY_ACCOUNT_COOKIE,
} from './verify-email.data';
import { environment } from '../../../environments';
import { shareReplay, take } from 'rxjs/operators';
import { AccountStore } from '../../store/stores';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { CookieService, NavigationService } from 'i2g-ng-utils';
import { BrowserManagerStore } from '../../../app/store/stores';

@Component({
  selector: 'app-verify-login',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailComponent implements OnInit, AfterViewInit {
  didSucceed: boolean;

  invoice2goLogo: IIcon;
  checkmarkIcon: IIcon;
  errorIcon: IIcon;
  ctaTrackingAction: ITrackingAction;
  trackingObject$: Observable<ITrackingObject>;
  trackingScreenName: TrackingScreenNamesEnum;

  constructor(
    private _trackingService: I2gNgTrackingService,
    private _translateService: TranslateService,
    private _accountStore: AccountStore,
    private _activatedRoute: ActivatedRoute,
    private _navigationService: NavigationService,
    private _browserManagerStore: BrowserManagerStore,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _cookieService: CookieService,
    private _title: Title
  ) {}

  ngOnInit() {
    this.invoice2goLogo = {
      name: 'invoice2go-logo-white',
      size: IconSizesEnum.custom,
    };
    this.checkmarkIcon = {
      name: 'checkmark',
      size: IconSizesEnum.x_large,
    };
    this.errorIcon = {
      name: 'error',
      size: IconSizesEnum.x_large,
    };

    this.didSucceed = this._activatedRoute.snapshot.data.didSucceed;

    if (this.didSucceed) {
      this._cookieService.setCookie(VERIFY_ACCOUNT_COOKIE, true);
    }

    this.trackingScreenName = this.didSucceed
      ? TrackingScreenNamesEnum.verify_email_success
      : TrackingScreenNamesEnum.verify_email_failure;

    this._title.setTitle(
      this.didSucceed
        ? this._translateService.instant('VERIFY_EMAIL.SUCCESS_TITLE')
        : this._translateService.instant('VERIFY_EMAIL.FAILURE_TITLE')
    );

    const ctaButtonIdentifier = this.didSucceed
      ? CtaButtonIdentifierEnum.back_to_invoice2go
      : CtaButtonIdentifierEnum.sign_in;

    this.ctaTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      ctaButtonIdentifier,
      this.trackingScreenName
    );
    this.trackingObject$ = this._accountStore
      .getTrackingObject()
      .pipe(shareReplay(1));
  }

  ngAfterViewInit() {
    this._trackingService.trackPage(this.trackingScreenName);
  }

  onCtaClicked() {
    if (this.didSucceed) {
      this._browserManagerStore
        .isWeb()
        .pipe(take(1))
        .subscribe((isWeb) =>
          this._navigationService.goToExternalUrl(
            isWeb ? environment.webAppURL : MOBILE_DEEPLINK
          )
        );
    } else {
      this._navigationService.goTo(['/']);
    }
  }
}
